import { FormControl, FormHelperText, InputAdornment, InputLabel, OutlinedInput, withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import Ojo from '../../assets/icons/Ojo';
import OjoTachado from '../../assets/icons/OjoTachado';
import useStyles from './CustomInputSyles';
var AdaptableInput = withStyles(function () { return ({
    input: {
        color: 'var(--text2)',
        padding: '13.5px 14px',
        fontFamily: 'var(--main-font)',
        fontSize: '.875rem',
    },
    disabled: {
        backgroundColor: 'var(--morado-l98)',
        color: 'var(--disabled-text)',
        fontSize: '.875rem',
    },
}); })(OutlinedInput);
var AdaptableFormControl = withStyles(function () { return ({
    root: {
        width: '100%',
        fontSize: '.875rem',
        borderColor: 'var(--border-cm)',
    },
}); })(FormControl);
var ErrorFormHelperText = withStyles(function () { return ({
    root: {
        color: 'var(--error)',
        fontFamily: 'var(--main-font)',
        fontSize: '.875rem',
    },
}); })(FormHelperText);
var CustomFormHelperText = withStyles(function () { return ({
    root: {
        color: 'var(--input-label)',
        fontFamily: 'var(--main-font)',
        fontSize: '.875rem',
    },
}); })(FormHelperText);
var CustomInput = function (_a) {
    var dataTestId = _a.dataTestId, value = _a.value, onBlur = _a.onBlur, onChange = _a.onChange, onPaste = _a.onPaste, onCopy = _a.onCopy, errors = _a.errors, touched = _a.touched, label = _a.label, name = _a.name, type = _a.type, placeholder = _a.placeholder, disabled = _a.disabled, className = _a.className, autocomplete = _a.autocomplete, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, helperText = _a.helperText;
    var AdaptableInputLabel = withStyles(function () { return ({
        root: {
            color: 'var(--input-label)',
            top: value ? '0' : '-4px',
            fontSize: '.875rem',
        },
        focused: {
            top: '0',
            fontSize: '.875rem',
        },
    }); })(InputLabel);
    var _b = useState(type), tipoInput = _b[0], setTipoInput = _b[1];
    var _c = useState(true), mostrarPass = _c[0], setMostrarPass = _c[1];
    var setearTipo = function () {
        if (type === 'password') {
            setTipoInput(mostrarPass ? 'text' : 'password');
        }
        else {
            setTipoInput(type);
        }
        setMostrarPass(!mostrarPass);
    };
    var styles = useStyles();
    return (React.createElement(AdaptableFormControl, { className: className, variant: "outlined" },
        React.createElement(AdaptableInputLabel, { htmlFor: "component-outlined" }, label),
        React.createElement(AdaptableInput, { fullWidth: true, id: name, name: name, value: value, onBlur: onBlur, onChange: onChange, onPaste: onPaste, onCopy: onCopy, error: touched && Boolean(errors), label: label, placeholder: placeholder, disabled: disabled, type: tipoInput, autoComplete: autocomplete, inputProps: { 'data-testid': dataTestId }, startAdornment: !startAdornment ? null : React.createElement(InputAdornment, { position: "end" }, startAdornment), endAdornment: type === 'password' || endAdornment ? (React.createElement(InputAdornment, { position: "end" }, type === 'password' ? (React.createElement("button", { className: styles.boton, type: "button", onClick: function () { return setearTipo(); } }, mostrarPass ? React.createElement(Ojo, { className: styles.iconoOjo }) : React.createElement(OjoTachado, { className: styles.iconoOjo }))) : (endAdornment))) : (React.createElement(React.Fragment, null)) }),
        touched && errors ? React.createElement(ErrorFormHelperText, null, errors) : React.createElement(CustomFormHelperText, null, helperText)));
};
CustomInput.defaultProps = {
    label: undefined,
    placeholder: '',
    className: '',
    type: 'text',
    disabled: false,
    errors: undefined,
    touched: undefined,
    autocomplete: 'on',
    startAdornment: undefined,
    endAdornment: undefined,
    helperText: '',
};
export default CustomInput;
